import { IonAlert } from "@ionic/react";
import { GroupChannel } from "@sendbird/chat/groupChannel";
import React from "react";
import { debug } from "../../../App";

export interface LeaveChannelAlertProps {
  isOpen: boolean;
  channel: GroupChannel;
  onSuccess: () => void;
}

export const LeaveChannelAlert = (props: LeaveChannelAlertProps) => {
  return (
    <IonAlert
      isOpen={props.isOpen}
      header={"Leave channel"}
      message={"Are you sure you want to leave this channel?"}
      buttons={[
        {
          text: "Cancel",
          role: "cancel",
          cssClass: "secondary",
        },
        {
          text: "Leave",
          handler: () => {
            props.channel
              .leave()
              .then(() => {
                props.onSuccess();
              })
              .catch((error: any) => {
                debug("LeaveChannelAlert", error);
              });
          },
        },
      ]}
    />
  );
};
